export let LexicalStatus = /*#__PURE__*/function (LexicalStatus) {
  LexicalStatus[LexicalStatus["Initial"] = 0] = "Initial";
  LexicalStatus[LexicalStatus["ExpectField"] = 1] = "ExpectField";
  LexicalStatus[LexicalStatus["ExpectOptionalBeginDefault"] = 2] = "ExpectOptionalBeginDefault";
  LexicalStatus[LexicalStatus["ExpectDefaultValue"] = 3] = "ExpectDefaultValue";
  LexicalStatus[LexicalStatus["ExpectOptionalBeginPipe"] = 4] = "ExpectOptionalBeginPipe";
  LexicalStatus[LexicalStatus["ExpectPipeIdentifier"] = 5] = "ExpectPipeIdentifier";
  LexicalStatus[LexicalStatus["ExpectOptionalBeginPipeParameter"] = 6] = "ExpectOptionalBeginPipeParameter";
  LexicalStatus[LexicalStatus["ExpectPipeParameter"] = 7] = "ExpectPipeParameter";
  LexicalStatus[LexicalStatus["ExpectPlaceholderEnd"] = 8] = "ExpectPlaceholderEnd";
  return LexicalStatus;
}({});
export let TokenType = /*#__PURE__*/function (TokenType) {
  TokenType["Raw"] = "Raw";
  TokenType["BeginPlaceHolder"] = "BeginPlaceHolder";
  TokenType["Field"] = "Field";
  TokenType["BeginDefault"] = "BeginDefault";
  TokenType["LiteralString"] = "LiteralString";
  TokenType["BeginPipe"] = "BeginPipe";
  TokenType["PipeIdentifier"] = "PipeIdentifier";
  TokenType["BeginPipeParameter"] = "BeginPipeParameter";
  TokenType["EndPlaceHolder"] = "EndPlaceHolder";
  TokenType["JsonValue"] = "JsonValue";
  return TokenType;
}({});
export let JsonValueType = /*#__PURE__*/function (JsonValueType) {
  JsonValueType[JsonValueType["Array"] = 0] = "Array";
  JsonValueType[JsonValueType["Object"] = 1] = "Object";
  JsonValueType[JsonValueType["String"] = 2] = "String";
  JsonValueType[JsonValueType["Others"] = 3] = "Others";
  return JsonValueType;
}({});
//# sourceMappingURL=interfaces.js.map